import { frontendHostUrl } from 'config';

export const getSlackAuthUrl = (
  type: 'board' | 'docs',
  boardId: string,
  orgId: string,
  viewId: string
) => {
  const slackClientId = process.env.SLACK_CLIENT_ID;
  const state = btoa(
    JSON.stringify({
      type: type,
      id: boardId,
      orgId,
      viewId,
    })
  );
  const scope = 'incoming-webhook';
  const redirect_uri = `${frontendHostUrl}slackcallback`;
  const slackAuthUrl = `https://slack.com/oauth/v2/authorize?scope=${scope}&client_id=${slackClientId}&state=${state}&redirect_uri=${redirect_uri}`;
  return slackAuthUrl;
};

export const getGithubAuthUrl = (
  type: 'board' | 'docs',
  boardId: string,
  orgId: string,
  viewId: string
) => {
  const githubClientId = process.env.GIT_CLIENT_ID;
  const state = btoa(
    JSON.stringify({
      type: type,
      id: boardId,
      orgId,
      viewId,
    })
  );
  const scope = 'repo';
  const redirect_uri = `${frontendHostUrl}gitcallback`;
  const githubAuthUrl = `https://github.com/login/oauth/authorize?response_type=code&scope=${scope}&client_id=${githubClientId}&state=${state}&redirect_uri=${redirect_uri}`;
  return githubAuthUrl;
};
